import Vue from 'vue';
let SEC = require('common/js/utils/core.js');

const API_HOME = process.env.API_HOME || '';
const API_USER_CENTER = process.env.API_USER_CENTER || '';

const APP_SOURCE = 60; // 渠道来源：40 微信小程序 60 M站，android和ios使用c_platform_type来标识0:ios；1:android

const UPK = SEC.cookie.get('Sid') || '';

/**
 *  查询优惠券列表
 *  接口文档地址：http://doc.secoo.com/workspace/myWorkspace.do?projectId=18#223
 *
 * @param page      {number}     当前页码
 * @param pageSize  {number}     每页显示条数
 * @param type      {number}     优惠券类型  1:未使用 2:已使用 3:已失效
 *
 *
 */
export function queryTickets(page, pageSize, type) {
  const API = `${API_HOME}/api/ticket/query_tickets`;
  return Vue.http.post(API, {
    page: page,
    pageSize: pageSize,
    type: type,
    c_upk: UPK,
    appsource: APP_SOURCE
  });
}

/**
 * 激活优惠券
 * 接口文档地址：http://doc.secoo.com/workspace/myWorkspace.do?projectId=18#229
 *
 * @param ticketSn {string} 优惠券码
 *
 */
export function activeTicket(ticketSn) {
  const API = `${API_HOME}/api/ticket/active`;
  return Vue.http.post(API, {
    c_upk: UPK,
    ticketSn: ticketSn,
    appsource: APP_SOURCE
  });
}

/**
 * 检测用户登录状态
 * 接口文档地址：http://doc.secoo.com/workspace/myWorkspace.do?projectId=109#2196
 *
 * @param {string} upk 用户登录标识
 *
 *
 */
export function checkUserLoginStatus(upk) {
  const API = `${API_USER_CENTER}/service/appapi/login/check`;
  return Vue.http.get(API, {
    params: {
      upk: upk,
      retExpandInfo: 0,
      retUserInfo: 0,
      appsource: APP_SOURCE
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js